export function getConfigs() {
	// eslint-disable-next-line no-undef
	const settings = { ...commentsConfig };
	// eslint-disable-next-line no-undef
	commentsConfig = {};

	return settings;
}

export async function fetchData(endpoint, options = {}) {
	const data = await fetch(endpoint, options).then((response) => {
		return response.json();
	});
	return data;
}

export function validateEmail(email) {
	// eslint-disable-next-line no-useless-escape
	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	if (email.match(mailformat)) {
		return true;
	}

	return false;
}

export function getRandomEmail() {
	return (
		'anonymous.user.' +
		(Date.now() * 0x10000).toString(16).substring(1) +
		'@example.com'
	);
}
